module.exports = __webpack_public_path__ + "img/genoa-logo-icon.f804c141.png";